import React, { Component, Fragment } from 'react'
import { v4 as uuid } from 'uuid'
import api from 'services/api'
import PropTypes from 'prop-types'
import './index.less'
import { Row, Col, message } from 'antd'
import { Header } from '/components/Header/'
import { GiftPageHero } from '/components/GiftPageHero'
import { GiftSending } from '/components/GiftSending'
import { AnimatedImages } from '/components/AnimatedImages'
import { SelectedGif } from '/components/SelectedGif'
import { GifSearchInput } from '/components/GifSearchInput'
import { MainText } from '/components/MainText'
import { SmsValidation } from '/components/SmsValidation'
import { CaptchaValidation } from '/components/CaptchaValidation'
import { Preview } from '/components/Preview'
import { generateNewFormattedString } from '/utils/checkString.js'

const serverErrorMessage =
  'Ocorreu um erro interno. Por favor, tente novamente em alguns minutos'

export class Main extends Component {
  state = {
    gifsUrl: [],
    isGift: false,
    isSms: false,
    isCaptcha: false,
    gifUrl: '',
  }

  async componentDidMount() {
    // Assign an identifier to the user's browser
    const browserIdentifier = localStorage.getItem('cid')

    if (!browserIdentifier) {
      localStorage.setItem('cid', uuid())
    }

    this.setState({ pin: this.props.match.params.pin })

    try {
      const { data } = await api.get(
        `/delivery-bundle/${this.props.match.params.pin}/check-auth-method`,
      )

      if (data.code === 'DeliveryBundleNotFound') {
        this.setState({ deliveryBundleStatus: data.code, isCaptcha: true })
      } else if (data.errors) {
        message.error(serverErrorMessage)
      } else {
        const { authMethod, isGift, giftStyles } = data

        if (authMethod == 'captcha') {
          this.setState({ isCaptcha: true, giftStyles, isGift })
        } else {
          this.setState({ isSms: true, giftStyles, isGift })
        }
      }
    } catch (error) {
      message.error(serverErrorMessage)
    }
  }

  editTitle = title => {
    let newString = generateNewFormattedString(title.split(' '))
    this.setState({ title: newString })
  }

  editText = text => {
    let newString = generateNewFormattedString(text.split(' '))
    this.setState({ text: newString })
  }

  selectGifCallback = gifUrl => {
    this.setState({ gifUrl })
  }

  render() {
    const {
      isGift,
      isCaptcha,
      verifiedSms,
      isSms,
      smsSent,
      giftStyles,
      gifUrl,
      pin,
      deliveryBundleStatus,
    } = this.state

    const allowCustomization = isGift && !giftStyles
    const showGiphyLogo = isGift && !!giftStyles
    let selectedGif = gifUrl

    if (gifUrl) {
      selectedGif = gifUrl
    }

    let title = ''
    let text = ''

    if (isGift) {
      if (this.props.location.state) {
        title = this.props.location.state.title
        text = this.props.location.state.text
      } else {
        title = 'Coloque o nome do seu amigo(a) aqui'
        text = 'Deixe uma mensagem especial para seu amigo (a) aqui'
      }

      if (this.state.title) {
        title = this.state.title
      }
      if (this.state.text) {
        text = this.state.text
      }

      if (giftStyles) {
        if (giftStyles.pageTitle) {
          title = giftStyles.pageTitle
        }
        if (giftStyles.pageText) {
          text = giftStyles.pageText
        }
        if (giftStyles.gifUrl) {
          selectedGif = giftStyles.gifUrl
        }
      }
    } else {
      title = 'Parabéns!'
      text = 'Sua compra foi processada e está disponível para resgate'
    }

    return (
      <Fragment>
        <div id='container'>
          <div className='wrapper'>
            <div id='main' style={{ marginRight: '0px' }} className='tab'>
              <Header />
              {allowCustomization && <GiftPageHero />}
              <Row id='delivery' type='flex'>
                <Col
                  className='opacity-anim'
                  xs={{ span: 24 }}
                  lg={{ span: 13 }}
                >
                  <div id={isGift ? 'gift-text' : 'text'}>
                    <MainText
                      editable={allowCustomization}
                      title={title}
                      text={text}
                      editText={this.editText}
                      editTitle={this.editTitle}
                    />
                  </div>

                  {isGift ? (
                    <Row id='gifs'>
                      <Col lg={{ span: 24 }}>
                        {allowCustomization && (
                          <GifSearchInput
                            selectGifCallback={this.selectGifCallback}
                          />
                        )}
                      </Col>
                      {isGift && (
                        <div className={selectedGif ? 'visible' : 'hidden'}>
                          <Col
                            style={{
                              marginTop: '1vh',
                              display: 'flex',
                            }}
                            lg={{ span: 24 }}
                          >
                            <SelectedGif
                              gif={selectedGif}
                              showGiphyLogo={showGiphyLogo}
                            />
                          </Col>
                        </div>
                      )}
                    </Row>
                  ) : null}
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 11 }} id='images'>
                  <div id='component'>
                    {(() => {
                      if (isGift && allowCustomization) {
                        return (
                          <GiftSending
                            pin={pin}
                            title={title}
                            text={text}
                            gifUrl={gifUrl}
                          />
                        )
                      } else {
                        const recentlySentSms =
                          !!localStorage.getItem('timerBeforeNextSms') &&
                          this.state.isSms

                        if (isCaptcha) {
                          return (
                            <CaptchaValidation
                              pin={pin}
                              deliveryBundleStatus={deliveryBundleStatus}
                            />
                          )
                        } else if (isSms) {
                          return (
                            <SmsValidation
                              pin={pin}
                              smsSent={
                                !recentlySentSms || verifiedSms ? smsSent : true
                              }
                            />
                          )
                        }
                      }
                    })()}
                  </div>

                  <AnimatedImages />
                </Col>
              </Row>
            </div>
            {allowCustomization && (
              <div id='preview-container' className='tab'>
                <Header />
                <GiftPageHero />
                <div id='preview-component'>
                  <Preview title={title} text={text} gifUrl={gifUrl} />
                </div>
              </div>
            )}
          </div>
        </div>
      </Fragment>
    )
  }
}
Main.propTypes = {
  /** Props from url */
  match: PropTypes.shape({
    params: PropTypes.shape({
      /** Delivery bundle pin */
      pin: PropTypes.string,
    }),
  }),

  /** Props from edit gift component */
  location: PropTypes.shape({
    state: PropTypes.shape({
      /** String chosen by the user to be the title of the gift page */
      title: PropTypes.string,

      /** String chosen by the user to be the text of the gift page */
      text: PropTypes.string,

      /** Gif url chosen by the user */
      gifUrl: PropTypes.string,
    }),
  }),
}
